import type { AppRouterContext } from "~/lib/router-runtime";
import type { RwaCategoryId } from "./registry";

export function createRwaMarketsRouteLoader(categoryId: RwaCategoryId) {
  return ({ context }: { readonly context: AppRouterContext }): void => {
    void import("./rwa-markets-route")
      .then(async ({ preloadRwaMarketsRoute }) => {
        await preloadRwaMarketsRoute(context, categoryId);
      })
      .catch(() => {
        // A stale deploy chunk is recovered by the global vite:preloadError
        // handler. Keep intent preloads from also emitting unhandledrejection.
      });
  };
}
